import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import '../styles/UserProfile.css';
import { fetchUserProfile } from '../utils/api';
import { generateFormData, userProfileMapping } from '../utils/PageUtils';

const UserProfile = ({ bearerToken }) => {
    const [profileData, setProfileData] = useState(null);
    const [profileError, setProfileError] = useState(null);

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await fetchUserProfile(bearerToken)
                if (response.success) {
                    setProfileData(response.data);
                } else {
                    setProfileError(response.message);
                }
            } catch {
                setProfileError('Unable to fetch profile data');
            }
        };
        fetchProfile();
    }, []);

    const profileDetails = profileData ? generateFormData(profileData, userProfileMapping) : [];

    return (
        <div className="user-profile-container">
            {profileError && (
                <Alert variant="danger" style={{ width: '80%', margin: '4%' }}>
                    {profileError}
                </Alert>
            )}

            {profileData && (
                <div className="card-style">
                    <h1 className="profile-heading">User Profile</h1>
                    <div className="divider-style"></div>

                    <div className="profile-grid">
                        {profileDetails.map(({ label, value }) => (
                            <div className="grid-row" key={label}>
                                <span className="label-style">{label}</span>
                                <span className="value-style">{value || "-"}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserProfile;
